<template>
<div class="card shadow mb-4" :class="{'calendar-style': !['Appliances', 'EV'].includes(current_page)}">
  <div id="calendar" class="card-body">
      <!-- SELECT PRODUCER -->
      <div v-if="user_is_admin" class="form-group">
        <label class="control-label">Producer:</label>
        <select v-model="selected_producerId" class="form-control" id="select-producer">
          <option>-</option>
          <option v-for="producer in producers" :key="producer._id || producer.id" v-bind:value="producer._id || producer.id">
            {{ producer.username }}
          </option>
        </select>
      </div>
      <!-- END SELECT PRODUCER -->

      <div v-if="current_page != 'EV'">
        <div class="form-group">
          <!-- SELECT GROUP -->
          <fieldset v-if="current_page == 'Appliances'">
            <label class="control-label">{{ $t('Appliance') }}:</label>
            <select v-model="selected_group" class="form-control" id="select-group" style="border-radius:0px;">
              <option v-for="group in groups" :key="group._id" :value="group._id">
              {{ group.device.appliance.type ? $t(group.device.appliance.type) : $t(group.name) }} 
              {{ group.device.appliance.brand ? `(${group.device.appliance.brand})` : null }}
              </option>
            </select>
          </fieldset>
          <fieldset v-if="current_page!='Samples' && current_page!='Appliances'">
            <label class="control-label">{{ $t('Device') }}:</label>
            <select v-model="selected_group" class="form-control" id="select-group" style="border-radius:0px;">
              <option v-for="group in groups" :key="group._id" :value="group._id">
              {{ group.name }}
              </option>
            </select>
          </fieldset>
         <!--  <fieldset v-if="current_page=='Substations'">
            <label class="control-label">{{ $t('Substation') }}:</label>
            <select v-model="selected_group" class="form-control" id="select-group" style="border-radius:0px;">
              <option v-for="group in groups" :key="group._id" :value="group._id">
              {{ group.name }}
              </option>
            </select>
          </fieldset> -->
          <!-- END SELECT GROUP -->
          <!-- SELECT DEVICE -->
          <fieldset v-if="current_page=='Samples'">
            <label class="control-label">{{ $t('Device') }}:</label>
            <select v-model="selected_device" class="form-control" id="select-device" style="border-radius:0px;">
              <option v-for="device in devices" :key="device.deviceId" :value="device.deviceId">{{ device.name }}</option>
            </select>
          </fieldset>
          <!-- END SELECT DEVICE -->
        </div>
      </div>

      <!-- SELECT PERIOD OF TIME -->
      <div class="form-group">
        <fieldset>
          <label class="control-label">{{ $t('Period_of_time') }}:</label>
          <select v-model="range" class="form-control" id="select-range">
            <option value="day" selected>{{ $t('Day') }}</option>
            <option v-if="current_page!='Samples'" value="week">{{ $t('Week') }}</option>
            <option v-if="current_page!='Samples'" value="month">{{ $t('Month') }}</option>
          </select>
        </fieldset>
      </div>
      <!-- END SELECT PERIOD OF TIME -->

      <!-- SELECT DATE(S) -->
      <div class="form-group">
        <fieldset>
          <label class="control-label">
            <span v-if="numpickers == 1">{{ $t('Date') }}:</span>
            <span v-else>{{ $t('Dates') }}:</span>
          </label>
          <div class="input-group date" v-for="num in parseInt(numpickers)" v-bind:key="'datetimepicker-'+num">
            <label class="input-group-addon btn" style="cursor:default!important" v-bind:for="'datetime-picker'+num">
              <span class="fa fa-calendar"></span>
            </label>
            <input type="text" readonly class="form-control datetimepicker-input" value="" :id="'datetime-picker-'+num" data-toggle="datetimepicker" :data-target="'#datetime-picker-'+num"/>
          </div>
        </fieldset>
      </div>
      <!-- END SELECT DATE(S) -->
      <!-- VIEW BUTTON -->
      <div class="form-group">
        <button @click="request_data" id="btn-show" class="btn btn-primary btn-block" style="margin-top: 5px">{{ $t('View') }}</button>
      </div>
      <!-- END VIEW BUTTON -->

      <!-- SELECT DATES FOR EXPORT -->
      <div v-if="current_page=='Samples'" class="form-group">
        <fieldset>
          <label class="control-label"><span>{{ $t('Dates') }}:</span></label>
          <div class="input-group">
            <label class="input-group-addon btn" >
              <span class="fa fa-calendar"></span>
            </label>
            <input type="text" id="datetime-picker-export-1" class="form-control" value="">
          </div>
          <div class="input-group">
            <label class="input-group-addon btn">
              <span class="fa fa-calendar"></span>
            </label>
            <input type="text" id="datetime-picker-export-2" class="form-control" value="">
          </div>
        </fieldset>
      </div>
      <!-- END SELECT DATE(S) -->
      <!-- EXPORT BUTTON -->
      <div v-if="current_page=='Samples'" class="form-group text-center">
        <button v-show="!loading" @click="export_csv" id="btn-export" class="btn btn-info btn-block" style="margin-top: 5px">{{ $t('Export') }} CSV</button>
        <LoadingSpinner v-if="loading"></LoadingSpinner>
      </div>
      <!-- END EXPORT BUTTON -->
  </div>
</div>
</template>

<script>
import '../assets/vendor/datetimepicker/js/bootstrap-datetimepicker.min.js';
import LoadingSpinner from './LoadingSpinner.vue';

export default {
  name: 'Calendar',
  props: ['numpickers'],
  components:{
    LoadingSpinner
  },
  data() {
    return {
      range: null,
      groups: [],
      devices: [],
      selected_producerId: null,
      selected_group: null,
      selected_device: null,
      datetimes: [],
      minDate: "2017/01/01",
      requestInterval: null,
      loading: false
    }
  },
  mounted: function(){
    if(!this.user_is_admin){
      this.range = 'day'
      this.selected_producerId = this.$store.getters.user_id
    }
      
    const timezone = this.$store.getters.timezone
    const datetime_picker_options = {
      format: 'DD/MM/YYYY',
      viewMode: 'days',
      ignoreReadonly: true,
      extraFormats: ['DD/MM/YYYY - DD/MM/YYYY'],
      locale: moment.locale(this.current_lang, {
        week: { dow: 1 }
      }),
      useCurrent: false,
      debug: false,
      minDate: "2017/01/01",
      maxDate: moment().millisecond(59).second(59).minute(59).hour(23),
      icons: {
        previous: "fas fa-chevron-left",
        next: "fas fa-chevron-right"
      }
    }

    if (this.current_page == "Samples"){
      $(`#datetime-picker-export-1`).datetimepicker(datetime_picker_options)
      $(`#datetime-picker-export-2`).datetimepicker(datetime_picker_options)
    }

    const self = this 

    for (let num=1; num<=this.numpickers; num++){
      this.datetimes.push(null)

      $(`#datetime-picker-${num}`).datetimepicker(datetime_picker_options)

      // ON DATEPICKER CHANGE
      $(`#datetime-picker-${num}`).on('dp.change', function (e) {
        if (self.range == "week") {
          const datetime = $(`#datetime-picker-${num}`).data("DateTimePicker").date()
          if (datetime) {
            //console.log("SELECTED:", datetime.toJSON())
           /*  let start = moment.tz(datetime.day(1).format("YYYY-MM-DD"), timezone);
            let end = start.clone().add(6, 'days') */

            let end = null
            let start = null
            if (datetime.day() == 0) { // if Sunday, pick last monday (-6) and add 6 days
              start = moment.tz(datetime.day(-6).format("YYYY-MM-DD"), timezone);
              end = start.clone().add(6, 'days')
            }
            else { // else any other day, pick this monday (1) and add 6 days
              start = moment.tz(datetime.day(1).format("YYYY-MM-DD"), timezone);
              end = start.clone().add(6, 'days')
            }
            $(this).val(start.format("DD/MM/YYYY")+" - "+end.format("DD/MM/YYYY"))
          }
          $(".active.day").parent().css('background-color', '#89b43f')
          $(".active.day").parent().find('td').addClass('active').css('background-color', '#89b43f')
        }
      })
      
      // ON DATEPICKER SHOW
      $(`#datetime-picker-${num}`).on('dp.show', function (e) {
        $(".active.day").css('background-color', '#89b43f')
        $(".active.month").css('background-color', '#89b43f')
        $(".active.year").css('background-color', '#89b43f')
        if (self.range == "week") {
          const datetime = $(`#datetime-picker-${num}`).data("DateTimePicker").date()
          if (datetime) {
            /* let start = moment.tz(datetime.day(1).format("YYYY-MM-DD"), timezone);
            let end = start.clone().add(6, 'days') */
            let end = null
            let start = null
            if (datetime.day() == 0) { // if Sunday, pick last monday (-6) and add 6 days
              start = moment.tz(datetime.day(-6).format("YYYY-MM-DD"), timezone);
              end = start.clone().add(6, 'days')
            }
            else { // else any other day, pick this monday (1) and add 6 days
              start = moment.tz(datetime.day(1).format("YYYY-MM-DD"), timezone);
              end = start.clone().add(6, 'days')
            }
            $(this).val(start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY"))
          }
          $(".active.day").parent().css('background-color', '#89b43f')
          $(".active.day").parent().find('td').addClass('active').css('background-color', '#89b43f')
        }
      })

      // ON DATEPICKER UPDATE
      $(`#datetime-picker-${num}`).on('dp.update', function (e) {
        $(".active.day").css('background-color', '#89b43f');
        $(".active.month").css('background-color', '#89b43f');
        $(".active.year").css('background-color', '#89b43f');
        if (self.range == "week") {
          $(".active.day").parent().css('background-color', '#89b43f');
          $(".active.day").parent().find('td').addClass('active').css('background-color', '#89b43f');
        }
      })

      if(!this.user_is_admin && (this.current_page == "Appliances" || this.current_page == "EV")) { 
        $(`#datetime-picker-${num}`).data("DateTimePicker").date(new Date())
        this.$nextTick( () => { 
          $(`#datetime-picker-${num}`).data("DateTimePicker").date(new Date())
        })
      }
    }
  },
  destroyed: function(){
    clearInterval(this.requestInterval)
  },
  methods: {
    create_interval: function(interval=60){
      const self = this
      if(this.requestInterval != null) clearInterval(this.requestInterval)
      const query = { producerId: this.selected_producerId, groupId: this.selected_group }
      this.requestInterval = setInterval( () => { self.request_data() }, interval*1000)
    },
    export_csv: async function(){
      const export_start = $("#datetime-picker-export-1").data("DateTimePicker").date()
      const export_end = $("#datetime-picker-export-2").data("DateTimePicker").date()
      const deviceId = this.selected_device
      const sourceId = this.devices.find(d => d.deviceId == deviceId).sourceId
      /* const downloadLink = document.createElement("a")
      downloadLink.href = `https://shift2dc.prsma.com/admin/exportcsv/${sourceId}/${deviceId}?start=${export_start.toJSON()}&end=${export_end.toJSON()}`
      downloadLink.target = "_blank"
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove(); */
      this.loading = true
      const data = await this.$store.dispatch('exportCSV', {sourceId, deviceId, export_start, export_end})
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'file.csv'); //or any other extension
      document.body.appendChild(link);
      this.loading = false
      link.click();
    },
    producers_with_appliances: function(){
      const producers = this.$store.getters.producers
      let producers_with_appliances = producers.filter(p => {
        let device = p.devices.find(d => d.appliance && d.appliance.type)
        if (device) return p
      })
      return producers_with_appliances
    },
    producers_with_ev: function(){
      const producers = this.$store.getters.producers
      let producers_with_ev = producers.filter(p => {
        let device = p.devices.find(d => d.ev && d.ev.number)
        if (device) return p
      })
      return producers_with_ev
    },
    request_data: function(){
      this.$store.dispatch('setRange', this.range)
      //let query = { producerId: this.selected_producerId, groupId: this.selected_group }
      //this.$emit('queryChanged', query)
      const timezone = this.$store.getters.timezone

      let datetimes = []
      let query = { producerId: this.selected_producerId, range: this.range }

      for (let num=1; num<=this.numpickers; num++){
        let datetime = $(`#datetime-picker-${num}`).data("DateTimePicker").date()  
        let datetimeUTC = moment.tz(datetime.format('YYYY-MM-DD'), timezone).toJSON()
        //if (this.range == 'week') datetimeUTC = moment.tz(datetime.day(1).format('YYYY-MM-DD'), timezone).toJSON()
        if (this.range == 'week') {
          if (datetime.day() == 0) datetimeUTC = moment.tz(datetime.day(-6).format("YYYY-MM-DD"), timezone).toJSON();
          else datetimeUTC = moment.tz(datetime.day(1).format("YYYY-MM-DD"), timezone).toJSON();
        }
        if (this.range == 'month') { 
          datetimeUTC = moment.tz(datetime.format('YYYY-MM'), timezone).toJSON()
          query.limit = true
        }
        datetimes.push(datetimeUTC)
      }

      if (this.current_page == "Appliances" || this.current_page == "EV") {
        clearInterval(this.requestInterval)
        if(moment.tz(datetimes[0], timezone).isSame(new Date(), "day")) this.create_interval()

        let total_group_id = null
        if(this.user_is_admin)
          total_group_id = this.$store.getters.remote_user_total_group_id(this.selected_producerId)
        else
          total_group_id = this.$store.getters.user_total_group_id

        this.$store.dispatch('setGroupId', this.selected_group)

        const groups = this.groups.filter(g => g.name != "Total")
        //this.$store.commit('clear_data')  
        //if (this.current_page == "Appliances")
          this.$store.dispatch('request_multi_data', { range: this.range, producerId: this.selected_producerId, groups, datetimes: datetimes[0], total_group_id })
        /* else 
          this.$store.dispatch('request_multi_data', { range: this.range, producerId: this.selected_producerId, groups, datetimes: datetimes[0] }) */
      }
      else if (this.current_page == "Samples"){
        this.$store.dispatch('request_data_samples', {
          range: this.range, 
          producerId: this.selected_producerId,
          deviceId: this.selected_device, 
          datetime: datetimes[0]
        })
      }
      else if (this.current_page == 'Comparison') {
        this.$store.dispatch('request_multi_data', {
          range: this.range, 
          producerId: this.selected_producerId,
          groups: this.selected_group,
          datetimes: datetimes
        })
      }
      else {
        const group = this.groups.find(g => g._id == this.selected_group)
        this.$store.dispatch('request_single_data', { 
          range: this.range, 
          producerId: this.selected_producerId, 
          groupId: this.selected_group, 
          batteries: group.bess || [],
          datetime: datetimes[0]
        })
      }
    }
  },
  watch:{
    selected_producerId: function(){
      this.$store.commit('clear_data')
      this.$store.commit('clear_current_data')
      this.$store.dispatch('setProducerId', this.selected_producerId)
      if (this.current_page != "Appliances" && this.current_page != "EV"){
        if (this.user_is_admin) {
          this.selected_group = this.$store.getters.remote_user_total_group_id(this.selected_producerId)
          this.groups = this.$store.getters.remote_user_groups(this.selected_producerId)
          this.devices = this.$store.getters.remote_user_devices(this.selected_producerId)
        }
        else {
          this.selected_group = this.$store.getters.user_total_group_id
          this.groups = this.$store.getters.user_groups 
        }
      }
      else {
        let devices = []
        let groups = []
        if (this.user_is_admin) {
          devices = this.$store.getters.remote_user_devices(this.selected_producerId)
          groups = this.$store.getters.remote_user_groups(this.selected_producerId)
        } 
        else {
          devices = this.$store.getters.user_devices
          groups = this.$store.getters.user_groups
        } 

        let appliance_groups = [{
          _id: "all", 
          name: this.$i18n.t('All'), 
          devicesIds: [], 
          device: { 
            appliance: { type: null, brand: null }
          }
        }]

        if (this.current_page == "Appliances") {
          devices.forEach(d => {
            if (d.appliance && Object.keys(d.appliance).length > 0){
              let device_group = groups.find(g => g.devicesIds.indexOf(d.deviceId) > -1 && g.devicesIds.length == 1)
              if (device_group){
                appliance_groups.push({ 
                  _id: device_group._id, 
                  devicesIds: device_group.devicesIds, 
                  name: `${d.appliance.type} (${d.appliance.brand})`,
                  device: { appliance: { type: d.appliance.type, brand: d.appliance.brand } }
                })
              }
            }
          })
        }
        else if (this.current_page == "EV"){
          devices.forEach(d => {
            if (d.ev && Object.keys(d.ev).length > 0){
              let device_group = groups.find(g => g.devicesIds.indexOf(d.deviceId) > -1 && g.devicesIds.length == 1)
              if (device_group){
                appliance_groups.push({ 
                  _id: device_group._id, 
                  devicesIds: device_group.devicesIds, 
                  name: device_group.name
                })
              }
            }
          })
        }

        this.groups = appliance_groups
        this.selected_group = appliance_groups[0]._id
      }
    },
    selected_group: function(){
      this.$store.dispatch('setGroupId', this.selected_group)
      if (this.selected_group != "all"){
        this.$store.dispatch('getFirstTimestamp', { producerId: this.selected_producerId, groupId: this.selected_group }).then((response) => {
          this.minDate = moment(new Date(response)).millisecond(0).second(0).minute(0).hour(0)
          for (let num=1; num<=this.numpickers; num++){
            $(`#datetime-picker-${num}`).data("DateTimePicker").minDate(this.minDate)
          }
        })
      }
      else {
        let promises = []
        this.groups.forEach(g => {
          if (g._id == "all") return
          promises.push(new Promise((resolve, reject) => {
            this.$store.dispatch('getFirstTimestamp', { groupId: g._id || g, producerId: this.selected_producerId }).then((response) => {
              if (!response) response = new Date().toJSON()
              resolve(new Date(response).valueOf())
            })
          }))
        }) 
        Promise.all(promises).then(timestamps => {
          if (timestamps.length) { 
            timestamps.sort((a,b) => a - b) 
            this.minDate = moment(new Date(timestamps[0])).millisecond(0).second(0).minute(0).hour(0)
            for (let num=1; num<=this.numpickers; num++){
              $(`#datetime-picker-${num}`).data("DateTimePicker").minDate(this.minDate)
            }
          }
          if (!this.user_is_admin && (this.current_page == "Appliances" || this.current_page == "EV")) {
            this.request_data()
          }
        })
      }
    },
    range: function(e) {
      _paq.push(['trackEvent', this.current_page, 'Escala', this.range])
      if (this.range == 'day' || this.range == 'week') {
        for (let num=1; num<=this.numpickers; num++) {
          $(`#datetime-picker-${num}`).data("DateTimePicker").format('DD/MM/YYYY')
          $(`#datetime-picker-${num}`).data("DateTimePicker").viewMode('days')
          $(`#datetime-picker-${num}`).data("DateTimePicker").minDate(this.minDate)
          $(`#datetime-picker-${num}`).data("DateTimePicker").clear()
        }
      } else if (this.range == 'month') {
        for (let num=1; num<=this.numpickers; num++){
          $(`#datetime-picker-${num}`).data("DateTimePicker").format('MM/YYYY')
          $(`#datetime-picker-${num}`).data("DateTimePicker").viewMode('months')
          $(`#datetime-picker-${num}`).data("DateTimePicker").minDate(moment(this.minDate).date(1) )
          $(`#datetime-picker-${num}`).data("DateTimePicker").clear()
        }
      }
    },
    current_lang: function(){
      this.groups[0].name = this.$i18n.t('All')
      for (let num=1; num<=this.numpickers; num++){
        $(`#datetime-picker-${num}`).data("DateTimePicker").options({
          locale: moment.locale(this.current_lang, {
            week: { dow: 1 }
          })
        })
      }
    }
  },
  computed: {
    user_is_admin: function(){
      return this.$store.getters.user_isAdmin
    },
    producers: function(){
      let producers = this.$store.getters.producers
      if (this.current_page == 'Appliances') return this.producers_with_appliances()
      else if (this.current_page == 'EV') return this.producers_with_ev()
      /* if (this.current_page == "Substations")
        producers = producers.filter(p => p.groups.find(g => g.hasOwnProperty('type') && g.type == "substation")) */
      return producers
    },
    current_page: function(){
      return this.$route.name
    },
    current_lang: function(){
      return this.$i18n.locale
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import '../assets/vendor/datetimepicker/css/bootstrap-datetimepicker.min.css';

.calendar-style {
  position:relative; 
  margin-right:auto;
}

input[type=text]:read-only {
  background-color: white!important;
}

.bootstrap-datetimepicker-widget table tr td,
.bootstrap-datetimepicker-widget table.table-condensed > tbody > tr > td, 
.bootstrap-datetimepicker-widget table.table-condensed > tbody > tr > th, 
.bootstrap-datetimepicker-widget table.table-condensed > tfoot > tr > td, 
.bootstrap-datetimepicker-widget table.table-condensed > tfoot > tr > th, 
.bootstrap-datetimepicker-widget table.table-condensed > thead > tr > td, 
.bootstrap-datetimepicker-widget table.table-condensed > thead > tr > td 
{ padding: 5px; }

.bootstrap-datetimepicker-widget table tr td.new { display: none!important; }

.bootstrap-datetimepicker-widget table tr td.disabled,
.bootstrap-datetimepicker-widget table tr td span.disabled,
.bootstrap-datetimepicker-widget table tr td.day.disabled,
.bootstrap-datetimepicker-widget table tr td.month.disabled,
.bootstrap-datetimepicker-widget table tr td.year.disabled { color: #dbd8d8 !important; }

.bootstrap-datetimepicker-widget table tr td.old { visibility: hidden!important; } 

@media only screen and (min-width : 1200px) {
  .calendar-style {
    margin-right: 15px;
    z-index:30;
  }
}
</style>